import { useMemo } from 'react';

import { TableRow, TableCell, Checkbox } from '@occc-app/design-system';
import { OpenCommerceUserFragment } from '@occc/graphql';
import { getPersonFullName } from '@occc-app/lib/person';

type RetailerNetworkUsersListItemProps = {
  user: OpenCommerceUserFragment;
  isItemSelected: boolean;
  handleItemSelect: (id: string) => void;
};

const RetailerNetworkUsersListItem = ({
  user,
  isItemSelected,
  handleItemSelect,
}: RetailerNetworkUsersListItemProps) => {
  const userFullName = useMemo(() => getPersonFullName(user.name), [user.name]);

  return (
    <TableRow key={user.uuid} selected={isItemSelected}>
      <TableCell padding='checkbox'>
        <Checkbox
          checked={isItemSelected}
          onClick={(event) => {
            event.stopPropagation();
            handleItemSelect(user.uuid);
          }}
        />
      </TableCell>
      <TableCell>{userFullName}</TableCell>
      <TableCell>{user.email}</TableCell>
      <TableCell>{user.phoneNumber}</TableCell>
    </TableRow>
  );
};

export default RetailerNetworkUsersListItem;
